import axios from 'axios'
import { formatLocalDateTime } from './dateUtils'

const service = axios.create({
  baseURL: '/api',
  timeout: 60000
})

function convertDates(obj) {
  if (obj === null || obj === undefined) return obj
  if (obj instanceof Date) return formatLocalDateTime(obj)
  if (Array.isArray(obj)) return obj.map(convertDates)
  if (typeof obj === 'object' && !(obj instanceof FormData)) {
    const result = {}
    for (const key of Object.keys(obj)) {
      result[key] = convertDates(obj[key])
    }
    return result
  }
  return obj
}

// 请求拦截器
service.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = token
    }
    if (config.data && !(config.data instanceof FormData)) {
      config.data = convertDates(config.data)
    }
    return config
  },
  error => Promise.reject(error)
)

// 响应拦截器
service.interceptors.response.use(
  res => res.data,
  error => {
    alert('请求异常：' + error.message)
    return Promise.reject(error)
  }
)

export default service